import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import TagService from "../../src/Services/Tag.service";
const TagLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        defaultIds: props.defaultIds,
        fetchItemsById: (ids) => {
            return TagService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return TagService.getTags(search, 100);
        },
        optionRenderer: function locationRenderer(tag) {
            return _jsx("span", { children: tag.name });
        },
    });
};
export default TagLookup;
